import * as Scrivito from "scrivito";
import metadataAttributes from "objs/_metadataAttributes";
import defaultPageAttributes from "objs/_defaultPageAttributes";

const Wizard = Scrivito.provideObjClass("Wizard", {
  attributes: {
    roomcontrolPopup: ["widgetlist", { only: "InfoPopupWidget" }],
    fireprotectionPopup: ["widgetlist", { only: "InfoPopupWidget" }],
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
  extractTextAttributes: ["roomcontrolPopup", "fireprotectionPopup"],
});

export default Wizard;
